import { useQuery } from "@tanstack/react-query";
import { getFidelizationConfiguration } from "@/shared/actions/campanas/fidelizacion.actions";

export const useFidelizationConfiguration = () => {
  const query = useQuery({
    queryKey: ["fidelization-configuration"],
    queryFn: getFidelizationConfiguration,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data?.data,
    loading: query.isLoading,
    refetch: query.refetch,
  };
};